/**
 * API client for the per-institution course catalog browser (admin backend, Phase 4).
 *
 * Institution scoping is via the X-Institution-Id header (added by the global
 * institutionFetch interceptor), matching Program Health / Prerequisites.
 */

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001';

export async function fetchCourses({ search, department, page, perPage } = {}) {
  const p = new URLSearchParams();
  if (search) p.set('search', search);
  if (department) p.set('department', department);
  if (page) p.set('page', page);
  if (perPage) p.set('per_page', perPage);
  const res = await fetch(`${API_URL}/api/catalog/courses?${p.toString()}`);
  if (!res.ok) throw new Error(`Failed to fetch courses: ${res.status}`);
  return res.json();
}

export async function fetchDepartments() {
  const res = await fetch(`${API_URL}/api/catalog/departments`);
  if (!res.ok) throw new Error(`Failed to fetch departments: ${res.status}`);
  return res.json();
}
